<template>
  <el-select v-model="value" filterable clearable :remote-method="getMctOptions" remote @change="handleChange"
             v-bind="$attrs">
    <el-option v-for="({label,value}) in options" :key="value" :label="label" :value="value" />
  </el-select>
</template>

<script setup>
import { ref, watch } from 'vue'
import { getMerchantList } from '@/api/settlement-center/account-detail.js'

const $props = defineProps(['modelValue'])
const $emits = defineEmits(['change'])
const value = ref($props.modelValue)
const options = ref([])

watch(() => $props.modelValue, (val) => {
  value.value = val
})

const getMctOptions = async (name) => {
  const params = {
    size: 20,
    page: 1,
    mct_name: name
  }
  const { result } = await getMerchantList(params)
  if (result) {
    options.value = result.data.rows.map(item => ({
      label: item.full_name,
      value: item.mct_code
    }))
  }
}

const handleChange = (val) => {
  $emits('change', val)
}
</script>

<style scoped lang="scss">

</style>